import { render } from "./Turns.vue?vue&type=template&id=589eb21f&scoped=true"
import script from "./Turns.vue?vue&type=script&lang=js"
export * from "./Turns.vue?vue&type=script&lang=js"

import "./Turns.vue?vue&type=style&index=0&id=589eb21f&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589eb21f"]])

export default __exports__